import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-apicompany',
  templateUrl: './apicompany.component.html',
  styleUrls: ['./apicompany.component.scss']
})
export class ApicompanyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
